import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  message: null
};

const appMainSlice = createSlice({
  name: 'appMain',
  initialState,
  reducers: {
    loadingStart: (state) => {
      state.loading = true;
    },
    loadingEnd: (state) => {
      state.loading = false;
    },
    showMessage: (state, action) => {
      let message = action.payload;
      if (message && message.error) {
        message = message.error;
      }
      state.message = message;
    },
    closeMessage: (state) => {
      state.message = null;
    }
  }
});

export const { loadingStart, loadingEnd, showMessage, closeMessage } = appMainSlice.actions;

export default appMainSlice.reducer;
